import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";
import { useTranslation } from "react-i18next";

function LineHeight() {
  const { canvas, selectedObject } = useContext(AppContext);
  const { t } = useTranslation();
  const [lineHeight, setLineHeight] = useState(
    (selectedObject as fabric.Textbox)?.get("lineHeight")
  );

  // triggered by clicking layers
  useEffect(() => {
    setLineHeight((selectedObject as fabric.Textbox)?.get("lineHeight"));
  }, [selectedObject]);

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = parseFloat(event.target.value);
    setLineHeight(value);
    (selectedObject as fabric.Textbox)?.set({ lineHeight: value });
    canvas?.renderAll();
  }

  return (
    <input
      type="number"
      onChange={onChange}
      value={lineHeight}
      step={0.1}
      className="w-full h-9 px-3 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
      placeholder={t("font_line_height_placeholder")}
    />
  );
}

export default LineHeight;
